// extracted by mini-css-extract-plugin
export default {"container":"About_container__hkzLn","topBar":"About_topBar__auYPO","button":"About_button__9Hje6","content":"About_content__0YtB0"};